class AccessibilityManager {
  constructor(){
    this.isManaging = false

    // Since simply existing connotes a need for accessibility, we simply need instantiation to trigger
    this.createAccessibilityListeners()
  }
  
  createAccessibilityListeners() {
    // This function creates listeners to toggle the "input mode" of the user
    // The inputmode determines how elements are stylized
    // Styling related to this class is found in _accessibility.scss
    
    // Prevents Duplicates
    if(this.isManaging){
      return
    }
    else{
      this.isManaging = true
    }

    // Mouse Mode - Elements do not have outlines when focused
    function handleFirstTab(e) {
      if (e.keyCode === 9) {
        document.body.classList.add('user-is-tabbing');

        window.removeEventListener('keydown', handleFirstTab);
        window.addEventListener('mousedown', handleMouseDownOnce);
      }
    }

    // Keyboard Mode - Elements will have outlines when focused
    function handleMouseDownOnce() {
      document.body.classList.remove('user-is-tabbing');

      window.removeEventListener('mousedown', handleMouseDownOnce);
      window.addEventListener('keydown', handleFirstTab);
    }

    window.addEventListener('keydown', handleFirstTab);
  }
}

module.exports = AccessibilityManager